import { EventEmitter, Readable, Writable } from "../../platform/PlatformTools";

//# sourceMappingURL=typings.js.map
